import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import '@hp/ui/styles/index.css';
import './styles/app.css';
import { AppRouter } from './router';
import { queryClient } from './api/queryClient';
import { ErrorBoundary } from './components/error-boundary';
import { installGlobalErrorReporting } from './lib/client-errors';
import { installDomMutationGuard } from './lib/dom-guard';

// Before React renders: tolerate browser page translation rewriting text nodes (see lib/dom-guard.ts)
installDomMutationGuard();
installGlobalErrorReporting();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
